import React from "react"
import Image from "gatsby-image"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination } from "swiper"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"

const photographerprofile = ({ content }) => {
  const galleryImages = {
    fluid: content.imageGallery?.localFile?.childImageSharp?.fluid,
    alt: content.imageGallery?.altText,
    caption: content.imageGallery[2]?.caption,
  }
  
  return (
    <div className="pt-24 pb-8">
      <article className="grid grid-cols-1 med:grid-cols-5 tab:grid-cols-7 desk:grid-cols-9 gap-x-5 gap-y-12">
        <div
          className={`my-auto ${
            content.reverseLayout
              ? `med:col-start-4 med:col-end-6 tab:col-start-5 tab:col-end-8 desk:col-start-6 desk:col-end-10`
              : `col-start-1 med:col-end-3 tab:col-end-4 desk:col-end-5`
          }`}
        >
          <Swiper
            modules={[Navigation, Pagination]}
            tag="div"
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{
              type: "fraction",
            }}
          >
            {content.imageGallery.map((image, index) => {
              return (
                <SwiperSlide key={index}>
                  <Image
                    fluid={image.localFile?.childImageSharp?.fluid}
                    className=" h-96 note:h-160"
                    // style={{ height: "640px" }}
                  />
                  <div className="flex items-start justify-between mt-5">
                    <p className="text-sm">{image.caption}</p>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
        <div
          className={`h-inherit my-auto ${
            content.reverseLayout
              ? `col-start-1 med:col-end-3 tab:col-end-4 desk:col-end-5 row-start-1`
              : `med:col-start-4 med:col-end-6 tab:col-start-5 tab:col-end-8 desk:col-start-6 desk:col-end-10`
          }`}
        >
          <h4 className="text-base">{content.location}</h4>
          <h3 className="text-mobmd my-7">{content.name}</h3>
          <p className="text-sm whitespace-pre-line">{content.description}</p>
        </div>
      </article>
    </div>
  )
}

export default photographerprofile
